/**
 * 程序主组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>
    <div id="home" :class="themeClass">
		<transition name="router-fade" mode="out-in">
    		<router-view name="app"></router-view>
    	</transition>
    </div>
</template>

<script>
import Login from 'components/pages/login/Login'
import Home from 'components/layouts/Home'
import Update from 'components/layouts/Update'
export default {
  name: 'app',
  components: {
  	Login,
  	Home,
  	Update
  },
  data() {
     return {
       	
     };
  },
  computed:{
  	 themeClass() {
  	 	return {
       		'skin-1': this.$store.state.global.theme === 'skin-1',
		    'skin-2': this.$store.state.global.theme === 'skin-2',
		    'skin-3': this.$store.state.global.theme === 'skin-3',
		    'fixed-nav':this.$store.state.global.fixednav
		   }
       	}
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?4e98d537